import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=0ba6e326&scoped=true&"
import script from "./eventList.vue?vue&type=script&lang=ts&"
export * from "./eventList.vue?vue&type=script&lang=ts&"
import style0 from "./eventList.vue?vue&type=style&index=0&id=0ba6e326&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6e326",
  null
  
)

export default component.exports